import { propTypes } from "react-bootstrap/esm/Image";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.css";
import "font-awesome/css/font-awesome.css";
import Session from "react-session-api";
import axios from "axios";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import ReturnClassToken from "../pages/Login/ReturnClassToken";
import { useNavigate } from "react-router-dom";


export default function Header() {

    
    //if (Session.get("loginsession") != null) {
    //    const result = Session.get("loginsession");
    //    var token = result.AccessToken;
    //    var uid = result.UserID;
    //    ReturnClassToken.UserName = result.UserName;
    //}

    const navigate = useNavigate;

    if (localStorage.getItem("loginsession") != null) {
        const result = JSON.parse(localStorage.getItem("loginsession"));

        //const result = JSON.parse(localStorage.getItem("loginsession"));
        //var token = result.AccessToken;
        //var uid = result.UserID;
        //var ID = result.ID;
        ReturnClassToken.UserName = result.UserName;
        console.log(result);
    }
    else {
        navigate("/");
    }

    function logout() {
        localStorage.clear();
        window.location.href = '/';
    }
   
    return ( 
        <>
            <div
                id="yoc_header"
                className="yoc-header yoc-grid__item  yoc-header--fixed py-4"
            >
                <button
                    className="yoc-header-menu-wrapper-close"
                    id="yoc_header_menu_mobile_close_btn"
                >
                    <i className="la la-close"></i>
                </button>
                <div
                    className="yoc-header-menu-wrapper"
                    id="yoc_header_menu_wrapper"
                    style={{ opacity: "1" }}
                >
                    <div
                        id="yoc_header_menu"
                        className="yoc-header-menu yoc-header-menu-mobile  yoc-header-menu--layout-tab "
                        style={{ width: "69vw" }}
                    >
                        <h3
                            className="text-uppercase pl-2 mob-padd text-dark "
                            style={{ width: "27%" }}
                        >
                            <span className="txt-orange lead">Welcome!</span>
                            <br /> Dips Academy
                        </h3>
                    </div>
                </div>

                <div className="yoc-header__topbar">
                    <div className="yoc-header__topbar-item dropdown">
                        <div
                            className="yoc-header__topbar-wrapper"
                            data-toggle="dropdown"
                            data-offset="10px,0px"
                            aria-expanded="false"
                        >
                            <span className="yoc-header__topbar-icon">
                                <img src="assets/media/ques_logo.jpg" className="w-75" />
                            </span>
                            <span className="yoc-hidden yoc-badge yoc-badge--dot yoc-badge--notify yoc-badge--sm"></span>
                        </div>
                        <div
                            className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg"
                            x-placement="bottom-end"
                            style={{
                                position: "absolute",
                                transform: "translate3d(-277px, 41px, 0px)",
                                top: "0px",
                                left: "0px",
                                willChange: "transform",
                            }}
                        >
                            <form>
                                <div className="yoc-head yoc-head--skin-light yoc-head--fit-x yoc-head--fit-b">
                                    <h3 className="yoc-head__title">Question Stats</h3>
                                </div>

                                <div className="tab-content">
                                    <div
                                        className="tab-pane active show"
                                        id="topbar_notifications_notifications"
                                        role="tabpanel"
                                    >
                                        <div
                                            className="yoc-notification yoc-margin-t-10 yoc-margin-b-10 yoc-scroll ps"
                                            data-scroll="true"
                                            data-height="300"
                                            data-mobile-height="200"
                                            style={{ height: "300px", overflow: "hidden" }}
                                        >
                                            <div className=" col-md-12 w-100">
                                                <div className="col-md-12 py-1">
                                                    <div className="yoc-portlet yoc-iconbox yoc-iconbox--animate-slow mb-0 p-2">
                                                        <div className="yoc-portlet__body p-1">
                                                            <div className="yoc-iconbox__body">
                                                                <div className="yoc-iconbox__icon1">
                                                                    {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                    className="yoc-svg-icon"
                                  >
                                    <g
                                      stroke="none"
                                      stroke-width="1"
                                      fill="none"
                                      fill-rule="evenodd"
                                    >
                                      <rect
                                        id="bound"
                                        x="0"
                                        y="0"
                                        width="24"
                                        height="24"
                                      ></rect>
                                      <path
                                        d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                                        id="Combined-Shape"
                                        fill="#000000"
                                        opacity="0.3"
                                      ></path>
                                      <path
                                        d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                                        id="Combined-Shape"
                                        fill="#000000"
                                      ></path>
                                    </g>
                                  </svg> */}
                                                                </div>
                                                                <div className="yoc-iconbox__desc">
                                                                    <h3 className="yoc-iconbox__title">
                                                                        <a className="yoc-link" href="#">
                                                                            498498
                                                                        </a>
                                                                    </h3>
                                                                    <div className="yoc-iconbox__content1">
                                                                        Unused Question
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 py-1">
                                                    <div className="yoc-portlet yoc-iconbox yoc-iconbox--animate mb-0 p-2">
                                                        <div className="yoc-portlet__body p-1">
                                                            <div className="yoc-iconbox__body">
                                                                <div className="yoc-iconbox__icon1">
                                                                    {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                    className="yoc-svg-icon"
                                  >
                                    <g
                                      stroke="none"
                                      stroke-width="1"
                                      fill="none"
                                      fill-rule="evenodd"
                                    >
                                      <rect
                                        id="bound"
                                        x="0"
                                        y="0"
                                        width="24"
                                        height="24"
                                      ></rect>
                                      <path
                                        d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                                        id="Combined-Shape"
                                        fill="#000000"
                                        opacity="0.3"
                                      ></path>
                                      <path
                                        d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
                                        id="check-path"
                                        fill="#000000"
                                      ></path>
                                      <path
                                        d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                                        id="Combined-Shape"
                                        fill="#000000"
                                      ></path>
                                    </g>
                                  </svg> */}
                                                                </div>
                                                                <div className="yoc-iconbox__desc">
                                                                    <h3 className="yoc-iconbox__title">
                                                                        <a className="yoc-link" href="#">
                                                                            4498
                                                                        </a>
                                                                    </h3>
                                                                    <div className="yoc-iconbox__content1">
                                                                        UnclassNameified Questions
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 py-1">
                                                    <div className="yoc-portlet yoc-iconbox yoc-iconbox--animate-fast mb-0 p-2">
                                                        <div className="yoc-portlet__body p-1">
                                                            <div className="yoc-iconbox__body">
                                                                <div className="yoc-iconbox__icon1">
                                                                    {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                  >
                                    <g
                                      stroke="none"
                                      stroke-width="1"
                                      fill="none"
                                      fill-rule="evenodd"
                                    >
                                      <rect
                                        x="0"
                                        y="0"
                                        width="24"
                                        height="24"
                                      ></rect>
                                      <path
                                        d="M5,8 L19,8 C20.1045695,8 21,8.8954305 21,10 L21,20 C21,21.1045695 20.1045695,22 19,22 L5,22 C3.8954305,22 3,21.1045695 3,20 L3,10 C3,8.8954305 3.8954305,8 5,8 Z M12,20 C14.7614237,20 17,17.7614237 17,15 C17,12.2385763 14.7614237,10 12,10 C9.23857625,10 7,12.2385763 7,15 C7,17.7614237 9.23857625,20 12,20 Z M11.5730613,13.5616319 L12,11 L12.4269387,13.5616319 C13.0473823,13.7455122 13.5,14.3198988 13.5,15 C13.5,15.8284271 12.8284271,16.5 12,16.5 C11.1715729,16.5 10.5,15.8284271 10.5,15 C10.5,14.3198988 10.9526177,13.7455122 11.5730613,13.5616319 Z"
                                        fill="#505050"
                                      ></path>
                                      <path
                                        d="M14,6 L14,8 L10,8 L10,6 L7.80277564,6 C6.67650121,6 5.62474465,5.43711697 5,4.5 L4.5182334,3.7773501 C4.36505717,3.54758575 4.4271441,3.23715108 4.65690845,3.08397485 C4.73904221,3.02921901 4.83554605,3 4.93425855,3 L19.0657415,3 C19.3418838,3 19.5657415,3.22385763 19.5657415,3.5 C19.5657415,3.59871249 19.5365224,3.69521634 19.4817666,3.7773501 L19,4.5 C18.3752554,5.43711697 17.3234988,6 16.1972244,6 L14,6 Z"
                                        fill="#505050"
                                        opacity="0.3"
                                      ></path>
                                    </g>
                                  </svg> */}
                                                                </div>
                                                                <div className="yoc-iconbox__desc">
                                                                    <h3 className="yoc-iconbox__title">
                                                                        <a className="yoc-link" href="#">
                                                                            452
                                                                        </a>
                                                                    </h3>
                                                                    <div className="yoc-iconbox__content1">
                                                                        Question without Answers
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 py-1">
                                                    <div className="yoc-portlet yoc-iconbox yoc-iconbox--animate-fast mb-0 p-2">
                                                        <div className="yoc-portlet__body p-1">
                                                            <div className="yoc-iconbox__body">
                                                                <div className="yoc-iconbox__icon1">
                                                                    {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                  >
                                    <g
                                      stroke="none"
                                      stroke-width="1"
                                      fill="none"
                                      fill-rule="evenodd"
                                    >
                                      <rect
                                        x="0"
                                        y="0"
                                        width="24"
                                        height="24"
                                      ></rect>
                                      <circle
                                        fill="#505050"
                                        opacity="0.3"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                      ></circle>
                                      <path
                                        d="M12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 Z M10.591,14.868 L10.591,13.209 L11.851,13.209 C13.447,13.209 14.602,11.991 14.602,10.395 C14.602,8.799 13.447,7.581 11.851,7.581 C10.234,7.581 9.121,8.799 9.121,10.395 L7.336,10.395 C7.336,7.875 9.31,5.922 11.851,5.922 C14.392,5.922 16.387,7.875 16.387,10.395 C16.387,12.915 14.392,14.868 11.851,14.868 L10.591,14.868 Z"
                                        fill="#505050"
                                      ></path>
                                    </g>
                                  </svg> */}
                                                                </div>
                                                                <div className="yoc-iconbox__desc">
                                                                    <h3 className="yoc-iconbox__title">
                                                                        <a className="yoc-link" href="#">
                                                                            452
                                                                        </a>
                                                                    </h3>
                                                                    <div className="yoc-iconbox__content1">
                                                                        Ques without Explanation
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane"
                                        id="topbar_notifications_events"
                                        role="tabpanel"
                                    >
                                        <div
                                            className="yoc-notification yoc-margin-t-10 yoc-margin-b-10 yoc-scroll ps"
                                            data-scroll="true"
                                            data-height="300"
                                            data-mobile-height="200"
                                            style={{ height: "300px", overflow: "hidden" }}
                                        >
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-psd yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New report has been received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        23 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon-download-1 yoc-font-danger"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Finance report has been generated
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        25 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-line-chart yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New order has been received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        2 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-box-1 yoc-font-brand"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New customer is registered
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        3 hrs ago
                                                    </div>
                                                </div>
                                            </a>

                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane"
                                        id="topbar_notifications_logs"
                                        role="tabpanel"
                                    >
                                        <div
                                            className="yoc-grid yoc-grid--ver"
                                            style={{ minHeight: "200px" }}
                                        >
                                            <div className="yoc-grid yoc-grid--hor yoc-grid__item yoc-grid__item--fluid yoc-grid__item--middle">
                                                <div className="yoc-grid__item yoc-grid__item--middle yoc-align-center">
                                                    All caught up!
                                                    <br />
                                                    No new notifications.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="yoc-header__topbar-wrapper d-flex align-items-center ml-sm-3">
                        <div className="yoc-widget__details">
                            <div className="yoc-section__content yoc-section__content--solid">
                                <div className="yoc-media-group">
                                    <a
                                        href="#"
                                        className="yoc-media yoc-media--sm yoc-media--circle"
                                        data-toggle="yoc-tooltip"
                                        data-skin="brand"
                                        data-placement="top"
                                        title=""
                                        data-original-title="Bijender"
                                    >
                                        <img src="assets/media/users/100_1.jpg" alt="image" />
                                    </a>
                                    <a
                                        href="#"
                                        className="yoc-media yoc-media--sm yoc-media--circle"
                                        data-toggle="yoc-tooltip"
                                        data-skin="brand"
                                        data-placement="top"
                                        title=""
                                        data-original-title="Gaurav"
                                    >
                                        <img src="assets/media/users/100_10.jpg" alt="image" />
                                    </a>
                                    <a
                                        href="#"
                                        className="yoc-media yoc-media--sm yoc-media--circle"
                                        data-toggle="yoc-tooltip"
                                        data-skin="brand"
                                        data-placement="top"
                                        title=""
                                        data-original-title="Deepanshu"
                                    >
                                        <span>+5</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="yoc-header__topbar-item dropdown">
                        <div
                            className="yoc-header__topbar-wrapper"
                            data-toggle="dropdown"
                            data-offset="10px,0px"
                            aria-expanded="false"
                        >
                            <span className="yoc-header__topbar-icon">
                                <i className="flaticon2-bell-alarm-symbol"></i>
                            </span>
                            <span className="yoc-hidden yoc-badge yoc-badge--dot yoc-badge--notify yoc-badge--sm"></span>
                        </div>
                        <div
                            className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg"
                            x-placement="bottom-end"
                            style={{
                                position: "absolute",
                                transform: "translate3d(-277px, 41px, 0px)",
                                top: "0px",
                                left: "0px",
                                willChange: "transform",
                            }}
                        >
                            <form>
                                <div className="yoc-head yoc-head--skin-light yoc-head--fit-x yoc-head--fit-b">
                                    <h3 className="yoc-head__title">
                                        User Notifications &nbsp;
                                        <span className="btn btn-label-primary btn-sm btn-bold btn-font-md waves-effect waves-light">
                                            23 new
                                        </span>
                                    </h3>
                                    <ul
                                        className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand  yoc-notification-item-padding-x"
                                        role="tablist"
                                    >
                                        <li className="nav-item waves-effect waves-light">
                                            <a
                                                className="nav-link active show"
                                                data-toggle="tab"
                                                href="#topbar_notifications_notifications"
                                                role="tab"
                                                aria-selected="true"
                                            >
                                                Alerts
                                            </a>
                                        </li>
                                        <li className="nav-item waves-effect waves-light">
                                            <a
                                                className="nav-link"
                                                data-toggle="tab"
                                                href="#topbar_notifications_events"
                                                role="tab"
                                                aria-selected="false"
                                            >
                                                Events
                                            </a>
                                        </li>
                                        <li className="nav-item waves-effect waves-light">
                                            <a
                                                className="nav-link"
                                                data-toggle="tab"
                                                href="#topbar_notifications_logs"
                                                role="tab"
                                                aria-selected="false"
                                            >
                                                Logs
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="tab-content">
                                    <div
                                        className="tab-pane active show"
                                        id="topbar_notifications_notifications"
                                        role="tabpanel"
                                    >
                                        <div
                                            className="yoc-notification yoc-margin-t-10 yoc-margin-b-10 yoc-scroll ps"
                                            data-scroll="true"
                                            data-height="300"
                                            data-mobile-height="200"
                                            style={{ height: "300px", overflow: "hidden" }}
                                        >
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-line-chart yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New order has been received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        2 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-box-1 yoc-font-brand"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New customer is registered
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        3 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-chart2 yoc-font-danger"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Application has been approved
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        3 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-image-file yoc-font-warning"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New file has been uploaded
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        5 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-drop yoc-font-info"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New user feedback received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        8 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-pie-chart-2 yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        System reboot has been successfully completed
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        12 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-favourite yoc-font-danger"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New order has been placed
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        15 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a
                                                href="#"
                                                className="yoc-notification__item yoc-notification__item--read"
                                            >
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-safe yoc-font-primary"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Company meeting canceled
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        19 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-psd yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New report has been received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        23 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon-download-1 yoc-font-danger"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Finance report has been generated
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        25 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon-security yoc-font-warning"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New customer comment recieved
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        2 days ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-pie-chart yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New customer is registered
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        3 days ago
                                                    </div>
                                                </div>
                                            </a>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane"
                                        id="topbar_notifications_events"
                                        role="tabpanel"
                                    >
                                        <div
                                            className="yoc-notification yoc-margin-t-10 yoc-margin-b-10 yoc-scroll ps"
                                            data-scroll="true"
                                            data-height="300"
                                            data-mobile-height="200"
                                            style={{ height: "300px", overflow: "hidden" }}
                                        >
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-psd yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New report has been received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        23 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon-download-1 yoc-font-danger"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Finance report has been generated
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        25 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-line-chart yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New order has been received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        2 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-box-1 yoc-font-brand"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New customer is registered
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        3 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-chart2 yoc-font-danger"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Application has been approved
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        3 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-image-file yoc-font-warning"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New file has been uploaded
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        5 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-drop yoc-font-info"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New user feedback received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        8 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-pie-chart-2 yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        System reboot has been successfully completed
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        12 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-favourite yoc-font-brand"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New order has been placed
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        15 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a
                                                href="#"
                                                className="yoc-notification__item yoc-notification__item--read"
                                            >
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-safe yoc-font-primary"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Company meeting canceled
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        19 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-psd yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New report has been received
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        23 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon-download-1 yoc-font-danger"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        Finance report has been generated
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        25 hrs ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon-security yoc-font-warning"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New customer comment recieved
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        2 days ago
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" className="yoc-notification__item">
                                                <div className="yoc-notification__item-icon">
                                                    <i className="flaticon2-pie-chart yoc-font-success"></i>
                                                </div>
                                                <div className="yoc-notification__item-details">
                                                    <div className="yoc-notification__item-title">
                                                        New customer is registered
                                                    </div>
                                                    <div className="yoc-notification__item-time">
                                                        3 days ago
                                                    </div>
                                                </div>
                                            </a>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-x"
                                                style={{ left: "0px", bottom: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-x"
                                                    tabIndex="0"
                                                    style={{ left: "0px", width: "0px" }}
                                                ></div>
                                            </div>
                                            <div
                                                className="ps__rail-y"
                                                style={{ top: "0px", right: "0px" }}
                                            >
                                                <div
                                                    className="ps__thumb-y"
                                                    tabIndex="0"
                                                    style={{ top: "0px", height: "0px" }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane"
                                        id="topbar_notifications_logs"
                                        role="tabpanel"
                                    >
                                        <div
                                            className="yoc-grid yoc-grid--ver"
                                            style={{ minHeight: "200px" }}
                                        >
                                            <div className="yoc-grid yoc-grid--hor yoc-grid__item yoc-grid__item--fluid yoc-grid__item--middle">
                                                <div className="yoc-grid__item yoc-grid__item--middle yoc-align-center">
                                                    All caught up!
                                                    <br />
                                                    No new notifications.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div
                        className="yoc-header__topbar-item yoc-header__topbar-item--quick-panel"
                        data-toggle="yoc-tooltip"
                        title=""
                        data-placement="right"
                        data-original-title="Quick panel"
                    >
                        <span
                            className="yoc-header__topbar-icon"
                            id="yoc_quick_panel_toggler_btn"
                        >
                            <i className="flaticon2-cube-1"></i>
                        </span>
                    </div>

                    <div className="yoc-header__topbar-item yoc-header__topbar-item--user">
                        <div
                            className="yoc-header__topbar-wrapper"
                            data-toggle="dropdown"
                            data-offset="0px,0px"
                        >
                            <div className="yoc-header__topbar-user d-block text-center">
                                <img
                                    className=""
                                    alt="Pic"
                                    src="assets/media/users/300_25.jpg"
                                />
                                <span className="yoc-header__topbar-welcome yoc-hidden-mobile">
                                    {ReturnClassToken.UserName}
                                </span>
                                {/* 
                                use below badge element instead the user avatar to display username's first letter(remove yoc-hidden className to display it)
                                <span className="yoc-badge yoc-badge--username yoc-badge--unified-success yoc-badge--lg yoc-badge--rounded yoc-badge--bolder">B</span>
                                */}
                            </div>
                        </div>
                        <div className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg" style={{ marginTop: "10px",}}   >
                            <div
                                className="yoc-user-card yoc-user-card--skin-dark yoc-notification-item-padding-x"
                                style={{ backgroundColor: "#c82019", padding:"10px 5px" }}
                            >
                                {/*<div className="yoc-user-card__avatar">*/}
                                {/*    <img*/}
                                {/*        className="yoc-hidden"*/}
                                {/*        alt="Pic"*/}
                                {/*        src="assets/media/users/300_25.jpg"*/}
                                {/*    />*/}

                                   
                                {/*</div>*/}
                                <div className="yoc-user-card__name">{ReturnClassToken.UserName}</div>
                                {/*<div className="yoc-user-card__badge">*/}
                                {/*    <span className="btn btn-success btn-sm btn-bold btn-font-md waves-effect waves-light">*/}
                                {/*        23 messages*/}
                                {/*    </span>*/}
                                {/*</div>*/}
                            </div>

                            <div className="yoc-notification">
                                
                                <Link
                                    to="user-profile"
                                    className="yoc-notification__item"
                                >
                                    <div className="yoc-notification__item-icon">
                                        <i className="flaticon2-calendar-3 yoc-font-success"></i>
                                    </div>
                                    <div className="yoc-notification__item-details">
                                        <div className="yoc-notification__item-title yoc-font-bold">
                                            My Profile
                                        </div>
                                        <div className="yoc-notification__item-time">
                                            Account settings and more
                                        </div>
                                    </div>
                                </Link>
                                {/*<a href="#" className="yoc-notification__item">*/}
                                {/*    <div className="yoc-notification__item-icon">*/}
                                {/*        <i className="flaticon2-mail yoc-font-warning"></i>*/}
                                {/*    </div>*/}
                                {/*    <div className="yoc-notification__item-details">*/}
                                {/*        <div className="yoc-notification__item-title yoc-font-bold">*/}
                                {/*            My Messages*/}
                                {/*        </div>*/}
                                {/*        <div className="yoc-notification__item-time">*/}
                                {/*            Inbox and tasks*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</a>*/}
                                {/*<a href="#" className="yoc-notification__item">*/}
                                {/*    <div className="yoc-notification__item-icon">*/}
                                {/*        <i className="flaticon2-rocket-1 yoc-font-danger"></i>*/}
                                {/*    </div>*/}
                                {/*    <div className="yoc-notification__item-details">*/}
                                {/*        <div className="yoc-notification__item-title yoc-font-bold">*/}
                                {/*            My Activities*/}
                                {/*        </div>*/}
                                {/*        <div className="yoc-notification__item-time">*/}
                                {/*            Logs and notifications*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</a>*/}
                                {/*<a href="#" className="yoc-notification__item">*/}
                                {/*    <div className="yoc-notification__item-icon">*/}
                                {/*        <i className="flaticon2-hourglass yoc-font-brand"></i>*/}
                                {/*    </div>*/}
                                {/*    <div className="yoc-notification__item-details">*/}
                                {/*        <div className="yoc-notification__item-title yoc-font-bold">*/}
                                {/*            My Tasks*/}
                                {/*        </div>*/}
                                {/*        <div className="yoc-notification__item-time">*/}
                                {/*            latest tasks and projects*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</a>*/}

                                {/*<a href="#" className="yoc-notification__item">*/}
                                {/*    <div className="yoc-notification__item-icon">*/}
                                {/*        <i className="flaticon2-cardiogram yoc-font-warning"></i>*/}
                                {/*    </div>*/}
                                {/*    <div className="yoc-notification__item-details">*/}
                                {/*        <div className="yoc-notification__item-title yoc-font-bold">*/}
                                {/*            Billing*/}
                                {/*        </div>*/}
                                {/*        <div className="yoc-notification__item-time">*/}
                                {/*            billing &amp; statements{" "}*/}
                                {/*            <span className="yoc-badge yoc-badge--danger yoc-badge--inline yoc-badge--pill yoc-badge--rounded">*/}
                                {/*                2 pending*/}
                                {/*            </span>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</a>*/}
                                <div className="yoc-notification__custom yoc-space-between">
                               

                                    <button
                                        onClick={logout}
                                        className="btn btn-label btn-label-brand btn-sm btn-bold waves-effect waves-light"
                                    >
                                        Sign Out
                                    </button>

                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
